import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["id", "height", "width"]
const _hoisted_2 = ["fill", "stroke"]
const _hoisted_3 = ["x", "y", "width", "height", "visibility"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BoxComponent = _resolveComponent("BoxComponent")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "gridParent",
    style: _normalizeStyle([_ctx.generalThemeStyles, {"width":"100%","height":"calc(100vh - 64px - 52px)","overflow-y":"auto","font-size":"8pt"}]),
    class: "scrollbar-hidden"
  }, [
    (_openBlock(), _createElementBlock("svg", {
      id: _ctx.layout.id,
      ref: "svg",
      class: "designer-container designer-layout",
      height: _ctx.layout.height,
      width: _ctx.layout.width,
      style: _normalizeStyle({
                transform: `scale(${_ctx.preview ? _ctx.transformRatio : 1})`,
                'transform-origin': 'top left',
            })
    }, [
      _createElementVNode("rect", {
        x: "0",
        y: "0",
        width: "100%",
        height: "100%",
        fill: !_ctx.preview ? 'rgba(227, 227, 227, 255)' : 'transparent',
        stroke: !_ctx.preview ? 'whitesmoke' : 'black',
        "stoke-width": "0.5",
        style: _normalizeStyle({ filter: !_ctx.preview ? 'none' : 'none' })
      }, null, 12, _hoisted_2),
      _createElementVNode("g", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layout.gridCells, (cell) => {
          return (_openBlock(), _createElementBlock("rect", {
            key: cell.id,
            x: cell.x,
            y: cell.y,
            width: cell.width,
            height: cell.height,
            stroke: "whitesmoke",
            "stoke-width": "0.5",
            fill: "transparent",
            style: {"border-collapse":"collapse"},
            visibility: _ctx.preview ? 'hidden' : 'visible'
          }, null, 8, _hoisted_3))
        }), 128))
      ]),
      _createElementVNode("g", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layout.children, (box) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            (box.visible)
              ? (_openBlock(), _createBlock(_component_BoxComponent, {
                  key: box.id,
                  box: box,
                  selected: _ctx.isBoxSelected(box),
                  selectedBoxObj: _ctx.selectedBox,
                  viewType: _ctx.preview ? 'PREVIEW' : 'EDITION',
                  onSelectedBox: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleSelectedBox($event))),
                  onMovedBox: () => {},
                  ref_for: true,
                  ref: "boxComponent"
                }, null, 8, ["box", "selected", "selectedBoxObj", "viewType"]))
              : _createCommentVNode("", true)
          ], 64))
        }), 256))
      ])
    ], 12, _hoisted_1))
  ], 4))
}